<template>
    <div class="page-wrapper">
        <h1>{{ user.first_name }} {{ user.last_name }}</h1>
        <form
            autocomplete="off"
            novalidate
            style="max-width: 500px"
        >
            <q-field>
                <h-input
                    :value="user.first_name"
                    :error="$v.user.first_name.$error"
                    @change="val => { user.first_name = val; save() }"
                    show-save-buttons
                    stack-label="Имя"
                    :disable="isFieldsDisabled"
                />
            </q-field>
            <q-field>
                <h-input
                    :value="user.last_name"
                    :error="$v.user.first_name.$error"
                    @change="val => { user.last_name = val; save() }"
                    show-save-buttons
                    stack-label="Фамилия"
                    :disable="isFieldsDisabled"
                />
            </q-field>
            <q-field>
                <h-input
                    :value="user.email"
                    :error="$v.user.email.$error"
                    @change="val => { user.email = val; save() }"
                    show-save-buttons
                    stack-label="Электронная почта"
                    :disable="isFieldsDisabled"
                />
            </q-field>
            <q-field>
                <h-input
                    :value="user.phone_number"
                    :error="$v.user.phone_number.$error"
                    @change="val => { user.phone_number = val; save() }"
                    show-save-buttons
                    stack-label="Телефон"
                    :disable="isFieldsDisabled"
                />
            </q-field>
            <q-field v-if="$auth.check('root')">
                <q-select
                    v-model="user.role"
                    @change="save"
                    :options="roles"
                    float-label="Роль"
                    :disable="isFieldsDisabled"
                />
            </q-field>
            <q-field>
                <h-input
                    :value="user.password"
                    :error="$v.user.password.$error"
                    @change="val => { user.password = val; save() }"
                    show-save-buttons
                    stack-label="Пароль"
                    :disable="isFieldsDisabled"
                />
            </q-field>
            <div class="row items-center">
                <q-field class="col-9">
                    <h-input
                        :value="user.intercom_user_id"
                        @change="val => { user.intercom_user_id = val; save() }"
                        show-save-buttons
                        stack-label="Intercom User ID"
                        :disable="isFieldsDisabled"
                    />
                </q-field>

                <q-btn
                    @click="openIntercomChat"
                    icon="call_made"
                    flat
                    round
                >
                    <q-tooltip>
                        Открыть профиль клиента
                    </q-tooltip>
                </q-btn>

                <q-btn
                    @click="updateIntercomId"
                    :loading="intercomChanging"
                    icon="sync"
                    class="hover-primary q-ml-sm"
                    flat
                    round
                >
                    <q-tooltip>
                        Обновить ID клиента
                    </q-tooltip>
                </q-btn>
            </div>
            <q-field>
                <div v-if="editable" class="row gutter-xs">
                    <div class="column">
                        <q-btn type="submit" :loading="user.loading">Сохранить</q-btn>
                    </div>
                    <div class="column">
                        <q-btn @click="editable=false">Отмена</q-btn>
                    </div>
                </div>
            </q-field>
        </form>

        <h2 v-if="projects">Проекты</h2>

        <div v-for="project in projects" :key="project.id">
            <router-link :to="'/projects/' + project.id">{{ project.name }}</router-link>
            <span v-if="project.is_owner">★</span>
        </div>

        <div
            v-if="$auth.check('root') && user.projects && !user.projects.length && !user.has_project_transactions"
            class="q-mt-xl flex justify-end"
        >
            <q-btn
                @click="deleteUser"
                icon="delete"
                color="negative"
                label="Удалить пользователя"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { QBtn, QField, QIcon, QInput, QPopover, QSelect, QTable, QTableColumns, QTd, QTh, QTooltip, QTr } from 'quasar'
import HInput from '@/HInput'
import _ from 'lodash'
import { email, minLength, required } from 'vuelidate/lib/validators'

export default {
    components: {
        QField,
        QInput,
        QSelect,
        QBtn,
        QIcon,
        QTable,
        QTableColumns,
        QTr,
        QTh,
        QTd,
        QPopover,
        HInput,
        QTooltip,
    },

    computed: {
        ...mapState({
            user (state) {
                let user = state.user.data

                return {
                    first_name: user.first_name || null,
                    last_name: user.last_name || null,
                    email: user.email || null,
                    phone_number: user.phone_number || null,
                    password: user.password || null,
                    role: user.role || null,
                    type: user.type || 'INDIVIDUAL',
                    intercom_user_id: user.intercom_user_id || null,
                    projects: user.projects,
                    has_project_transactions: user.has_project_transactions,
                }
            },
        }),

        projects () {
            return _.sortBy(this.user.projects, 'is_owner').reverse()
        },
    },

    data () {
        return {
            transactions: [],

            roles: [
                {
                    value: 'user',
                    label: 'Пользователь',
                },
                {
                    value: 'manager',
                    label: 'Менеджер',
                },
                {
                    value: 'root',
                    label: 'Админ',
                },
                {
                    value: 'accountant',
                    label: 'Бухгалтер',
                },

            ],

            loading: false,

            editable: false,

            intercomChanging: false,
            isFieldsDisabled: !this.$auth.check('root'),
        }
    },

    validations: {
        user: {
            first_name: { required },
            last_name: { required },
            email: { required, email },
            phone_number: { required },
            password: { minLength: minLength(6) },
        },
    },

    methods: {
        save () {
            let user = Object.assign({}, this.user)

            if (!user.password) {
                delete user.password
            }
            this.$store.commit('user/setUser', user)
            this.$http.put(`api/v1.0/users/${this.$route.params.id}`, user).then((response) => {
                this.$q.notify({
                    message: `Сохранено`,
                    type: 'positive',
                    position: 'bottom',
                })

                this.updateIntercomId()
            }).catch((error) => {
                if (error.response.data.message) {
                    this.$q.notify({ message: error.response.data.message, type: 'negative' })
                }
                if (error.response.data.errors) {
                    _.forIn(error.response.data.errors, (value, key) => {
                        this.$q.notify({ message: value[0], type: 'negative' })
                    })
                }
            })
        },

        deleteUser () {
            let message = `Вы действительно хотите удалить данного клиента?`

            this.$q.dialog({
                title: 'Удаление клиента',
                message,
                color: 'primary',
                ok: true,
                cancel: true,
                position: 'top',
            }).then(() => {
                this.$http.delete(`api/v1.0/users/${this.$route.params.id}`).then((response) => {
                    this.$router.push('/users')
                    this.$q.notify('Deleted')
                }).catch((error) => {
                    console.log(error.response.data.errors)
                    _.forIn(error.response.data.errors, (value, key) => {
                        this.$q.notify(value[0])
                    })
                })
            })
        },

        allowEmailEdit (user) {
            return this.$auth.check('root') ||
                (this.$auth.check('manager') && user.role === 'user')
        },

        openIntercomChat () {
            window.open(
                `https://app.intercom.com/a/apps/xr5cw062/users/${this.user.intercom_user_id}/all-conversations`,
                '_blank',
            )
        },

        updateIntercomId () {
            this.intercomChanging = true

            this.$http.patch(`api/v1.0/users/${this.$route.params.id}/intercom`, this.user).then(response => {
                this.user.intercom_user_id = response.data.intercom_user_id

                let user = Object.assign({}, this.user)

                this.$store.commit('user/setUser', user)

                this.intercomChanging = false
                this.$q.notify({
                    message: `Обновлен Intercom ID`,
                    type: 'positive',
                    position: 'bottom',
                })
            }).catch(error => {
                this.intercomChanging = false
                this.$q.notify({ message: error, type: 'negative' })
            })
        },
    },
}
</script>

<style scoped lang="scss">

</style>




// WEBPACK FOOTER //
// resources/assets/js/views/UserDetailsView.vue